export default __webpack_public_path__ + "static/media/fridge1-before1-768w.88f47d26.png";